const HR_ALL_CURRENT_COMPONENT = 'HR_ALL_CURRENT_COMPONENT';
const HR_ALL_SERVICE_SUCCESS = 'HR_ALL_SERVICE_SUCCESS';
const HR_ALL_SERVICE_ERROR = 'HR_ALL_SERVICE_ERROR';
export const HR_ALL_SERVICE_COMPLETE_TIME = 'HR_ALL_SERVICE_COMPLETE_TIME';

export function logComponent<T>(page: T) {
    console.log(`${HR_ALL_CURRENT_COMPONENT}-> component name: ${page.constructor.name}`);
}

export function logServiceSuccessResponse<T>(response: T, uid: string) {
    //console.log(`${HR_ALL_SERVICE_SUCCESS}__${uid}-> response: ${JSON.stringify(response)}`);
}

export function logServiceErrorResponse(error: any, uid: string) {
    //console.log(`${HR_ALL_SERVICE_ERROR}__${uid}-> error: ${JSON.stringify(error)}`);
}

export function logServiceComplete(uid: string) {
    //console.timeEnd(uid);
}

export function getUniqueId(): string {
    const stringArr = [];
    for (let i = 0; i < 4; i++) {
        // tslint:disable-next-line:no-bitwise
        const S4 = (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        stringArr.push(S4);
    }
    return stringArr.join('-');
}
